import ModeFastActiveIcon from '@/pages/aigc/assets/svg/mode-fast-active-icon.svg';
import ModeDeepActiveIcon from '@/pages/aigc/assets/svg/mode-deep-active-icon.svg';
import FastPointIcon from '@/pages/aigc/assets/svg/fastPoint.svg';
import DeepseekPointIcon from '@/pages/aigc/assets/svg/deepseekPoint.svg';
import ModeAutoIcon from '../svg/agen-mode-auto.svg';
import ModeFastIcon from '../svg/agent-mode-fa.svg';
import ModeDeepIcon from '../svg/agent-mdel-ds.svg';
type TObjKeyValueString =  { [key: string]: string; };

// 全部映射为大写
export const ALL_TO_UPPERCASE_MAP: TObjKeyValueString = {
  'pc': "PC",
  'mobile': "Mobile",
  'console': "Console",
  'pc/console': 'PC & Console',
};

// 和东哥确认情报key按照文档中提供的来，如果有空格的话，key可能为驼峰格式，这里兼容下key可能为驼峰的格式
export const METRIC_DISPLAY_NAME: TObjKeyValueString  = {
  'ampere_mau': 'MAU',
  'dau_daily': 'DAU',
  'revenue': 'Revenue',
  'digitalrevenue': 'Digital Revenue',
  // 'est_revenue': 'Est.Revenue',
  'pcu': 'PCU',
  'downloads': 'Downloads',
  'sessions': 'sessions',
  'retention_rate': 'Retention%',
  'dau': 'DAU',
  'mau': 'MAU',
  'wau': 'WAU',
  'total_users': 'TNU',
  'new_users': 'New',
  'active_users': 'DAU',
  'net_revenue': 'Revenue After Refund & Tax($)',
  'revenue_after_chargeback': 'Revenue After Refund($)',
  'units_number': 'Base Game Units After Refund',
  'gross_revenue': 'Pc Gross Revenue',
  'full_game_gross_revenue': 'Base Game Revenue($)',
  'mtx_revenue': 'In-Game Revenue($)',
  'mtx_payers': 'In-Game Payer',
  'mtx_payer_rate': 'In-Game Payer%',
  'mtx_arpu': 'In-Game ARPU',
  'mtx_arppu': 'In-Game ARPPU',
  'd1': 'D1',
  'd2': 'D2',
  'd3': 'D3',
  'd4': 'D4',
  'd5': 'D5',
  'd6': 'D6',
  'd7': 'D7',
  'd14': 'D14',
  'd30': 'D30',
  'acu': 'ACU',
  'aot_hour': 'Avg.Playtime(h)',
  'alc': 'Sessions per user',
  'avg_session_time': 'Avg.Session Length',
  'retention_users': 'DAU Retention Users',
  'churn_users': 'Churn Users',
  'churn_rate': 'Churn%',
  'return_users': 'DAU Return Users',
  'weighted_d2': 'Weighted D1',
  'weighted_d3': 'Weighted D2',
  'weighted_d7': 'Weighted D6',
  'weighted_d14': 'Weighted D13',
  'first_login_ratio': '1st Order Login%',
  'second_login_ratio': '2nd Order Login%',
  'dwm': 'DAU',
  'total_online_time': 'Total duration of all sessions(min)',
  'average_online_time': 'Average Playtime(min)',
  'login_count': 'Sessions',
  'average_online_time_per_login': 'Average session length(min)',
  'onlinecnt': 'Concurrent',
  'lifetime_full_game_gross_units': 'Lifetime Gross Base Game Units',
  'gross_full_game_units': 'Gross Base Game Units',
  'lifetime_full_game_net_units': 'Lifetime Base Game Units After Refund',
  'lifetime_revenue_after_refund': 'Lifetime Revenue After Refund',
  'lifetime_refund_rate': 'Lifetime Refund Rate',
  'median_online_time': 'Median Playtime(h)',
  'above_2hr_users': 'Playtime over 2h+ new users',
  'median_session_time': 'Median Session',
  'avg_session_cnt': 'Avg.Session count',
  'profit': 'Revenue($)',
  'net_units_sold': 'Units After Refund',
  'units_net_revenue': 'Base Game Revenue After Refund & Tax($)',
  'gross_units_sold': 'Gross Units',
  'refund_revenue': 'Refund Revenue($)',
  'refunded_units': 'Refunded Units',
  'third_party_units': 'Third-party Units',
  'asp': 'Average Selling Price',
  'total_online_time_hour': 'Total duration of all sessions(h)',
  'average_online_time_per_login_hour': 'Average session length(h)',
  'new_user_mtx_payer_rate': 'MTX Payer%(New Users)',
  'mtx_new_paid_users': 'First-time MTX Payer',
  'mtx_new_pay_amount': 'Rev(First-time MTX Payer)',
  'mtx_new_arpu': 'First-time MTX Payer ARPU',
  'new_user_arpu': 'New User ARPU($)',
  'total_pay_days': 'Total Pay Days',
  'avg_active_users': 'Month Avg.DAU',
  'avg_new_users': 'Avg.Daily New',
  'm1': 'M1',
  'm2': 'M2',
  'm3': 'M3',
  'w1': 'W1',
  'w2': 'W2',
  'w3': 'W3',
  // 情报指标映射，先添加这三种的，等东哥确认之后删除多余的映射
  'hoursWatched': 'Hours Watched',
  'peackCCV': 'Peak CCV',
  'avgCCV': 'Avg CCV',
  'airtime': 'Airtime',
  'ampere_churned_mau': 'Churned Users',
  // 情报其他指标
  'gsd_digitalRevenue': 'Digital Revenue',
  'gsd_digitalUnits': 'Digital Units',
  'gsd_physicalRevenue': 'Physical Revenue',
  'gsd_physicalUnits': 'Physical Units',
  'ampere_avg_monthly_playtime': 'Avg Monthly Playtime (hours)',
  'ampere_acquisition_rate': 'Acquisition Rate',
  'ampere_stickiness': 'Stickiness',
  'ampere_lifetime_users': 'Lifetime Players',
  'ampere_previous_mau': 'Previous MAU',
  'ampere_added_mau': 'Added Users',
  'ampere_new_mau': 'New Users',
  'ampere_retained_mau': 'Retained Users',
  // 'ampere_churned_mau': 'Churned Users',
  'ampere_dau': 'DAU',
  'ampere_new_dau': 'New Users',
  'ampere_avg_dailly_playtime': 'Avg Dailly Playtime (hours)',
  'ampere_d1': 'D1',
  'ampere_d7': 'D7',
  'ampere_d14': 'D14',
  'ampere_d28': 'D28',
  'ampere_d60': 'D60',
  'ampere_rolling_d1': 'Rolling D1',
  'ampere_rolling_d7': 'Rolling D7',
  'ampere_rolling_d14': 'Rolling D14',
  'ampere_rolling_d28': 'Rolling D28',
  'ampere_rolling_d60': 'Rolling D60',

  'D1': 'Retention D1',
  'D2': 'Retention D2',
  'D3': 'Retention D3',
  'D4': 'Retention D4',
  'D5': 'Retention D5',
  'D6': 'Retention D6',
  'D7': 'Retention D7',
  'D14': 'Retention D14',
  'D30': 'Retention D30',
  'D60': 'Retention D60',
  'D90': 'Retention D90',
  'download': 'Downloads',
  // 'revenue': 'Revenue',
  'dau_weekly': 'WAU',
  'dau_monthly': 'MAU',
  'digitalRevenue': 'Digital Revenue',
  'units': 'Digital Units',
  'units_sold': 'Digital Units',
  'digitalARPPU': 'Digital ARPPU',
  'ast': 'Digital AST',
  'wishlists': 'Daily Wishlist',
  'wishlists_total': 'Lifetime Wishlist',
  'est_revenue': 'Revenue',
  'est_units': 'Units',
  'est_cumulative_revenue': 'Total Revenue',
  'est_cumulative_units': 'Total Units Sold',
  'est_price': 'Price',
  'weighted_price': 'Weighted Price',
  'players': 'Players by country',
  'playtime': 'Avg. Playtime',
  'followers': 'Followers',
  'sales': 'sales',
  'cumulative_sales': 'Cumulative Sales',
  'price': 'Price',
  'cumulative_revenue': 'Cumulative Revenue',
  'npd_revenue': 'Physical Revenue',
  'npd_units_sold': 'Physical Units',
  'company_npd': 'Company Revenue',
  // 和后端核对直接用PCU、ACU
  // 'pcu': 'Steam PCU',
  // 'acu': 'Steam ACU',

  'appstore top free': 'Top Free',
  'appstore top grossing': 'Top Grossing',
  'appstore top paid': 'Top Paid',
  'googleplay top free': 'Top Free',
  'googleplay top grossing': 'Top Grossing',
  'googleplay top paid': 'Top Paid',

  'googleplay top new free': 'Top New Free',
  'googleplay top new paid': 'Top New Paid',
  'epic top popular': 'Top Popular',
  'epicTopPopular': 'Top Popular',
  'epic top sellers': 'Top Sellers',
  'epicTopSellers': 'Top Sellers',
  'steam new and trending': 'New Trending',
  'daily steam top 100 sellers': 'Top Sellers',
  'steam top wish lists': 'Top Wish Lists',
  'xbox most played': 'Most Played',
  'xbox new release': 'New Release',
  'xbox upcoming': 'Upcoming',
  'xbox best rated': 'xbox Best Rated',
  'xbox top paid': 'xbox Top Paid',
  'xbox top free': 'xbox Top Free',
  'playstation best selling': 'Best Selling',
  'playstation most downloaded': 'Most downloaded',
  'playstation new games': 'New Games',
  'playstation coming soon': 'Coming Soon',
  'playstation indies games': 'Indies Games',
  'playstation free to play': 'Free to Play',
  'nintendo best sellers': 'Best Sellers',
  'nintendo new release': 'New Releases',
  'nintendo coming soon': 'Coming Soon',
  'Game Streaming': 'Streaming Viewers'
};

export const SOURCE_DIMENSION_NAME_MAP: TObjKeyValueString = {
  "pc/console": "PC & Console",
  "ampere": "Other Vendor",
  "vginsights": "VG Insights",
  "npd": "NPD",
  "stream": "Stream Hatchet",
  "mscience": "M Science",
  "gsd": "GSD",
  "sensortower": "Sensor Tower"
};

export const DIMENSION_NAME_MAP: {
  [key: string]: TObjKeyValueString; 
} = {
  // 有几个相同的，是后端确认的
  source: {
    'mscience': 'M Science',
    'gsd': 'GSD',
    'vginsights': 'VG Insights',
    'npd': 'NPD',
    'newzoo_weight': 'No-Update',
    'newzoo': 'No-Update',
    'ampere': 'Other Vendor',
    'famitsu': 'Japan Sales',
    'steamcharts': 'VG Insights',
    'channel': 'Streaming',
    'sensortower': 'Sensor Tower',
    'appannie': 'data.ai',
    'stream': 'Stream Hatchet',
  },
  market_name: {
    "AO": "Angola",
    "BJ": "Benin",
    "BW": "Botswana",
    "BF": "Burkina Faso",
    "CV": "Cape Verde",
    "TD": "Chad",
    "CG": "Congo",
    "CIV": "Côte d'Ivoire",
    "CU": "Cuba",
    "CD": "DR Congo",
    "ET": "Ethiopia",
    "GM": "Gambia",
    "GH": "Ghana",
    "GW": "Guinea-Bissau",
    "KE": "Kenya",
    "LR": "Liberia",
    "MG": "Madagascar",
    "MW": "Malawi",
    "ML": "Mali",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NE": "Niger",
    "NG": "Nigeria",
    "ST": "Sao Tome and Principe",
    "SN": "Senegal",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "ZA": "South Africa",
    "SZ": "Swaziland",
    "TZ": "Tanzania",
    "UG": "Uganda",
    "ZW": "Zimbabwe",
    "HK": "Hong Kong, China",
    "MO": "Macau, China",
    "TW": "Taiwan, China",
    "CN": "China",
    "AL": "Albania",
    "AM": "Armenia",
    "AZ": "Azerbaijan",
    "BY": "Belarus",
    "BA": "Bosnia and Herzegovina",
    "BG": "Bulgaria",
    "HR": "Croatia",
    "CZ": "Czech Republic",
    "EE": "Estonia",
    "GE": "Georgia",
    "GR": "Greece",
    "HU": "Hungary",
    "KZ": "Kazakhstan",
    "KG": "Kyrgyzstan",
    "LV": "Latvia",
    "LT": "Lithuania",
    "MD": "Moldova",
    "MK": "North Macedonia",
    "PL": "Poland",
    "RO": "Romania",
    "RU": "Russia",
    "RS": "Serbia",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "TJ": "Tajikistan",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "UA": "Ukraine",
    "UZ": "Uzbekistan",
    "BD": "Bengal",
    "IN": "India",
    "NP": "Nepal",
    "PK": "Pakistan",
    "JP": "Japan",
    "DZ": "Algeria",
    "BH": "Bahrain",
    "CY": "Cyprus",
    "EG": "Egypt",
    "IR": "Iran",
    "IQ": "Iraq",
    "IL": "Israel",
    "JO": "Jordan",
    "KW": "Kuwait",
    "LB": "Lebanon",
    "LY": "Libya",
    "MA": "Morocco",
    "OM": "Oman",
    "QA": "Qatar",
    "SA": "Saudi Arabia",
    "SY": "Syria",
    "TN": "Tunisia",
    "AE": "United Arab Emirates",
    "YE": "Yemen",
    "VG": "British Virgin Islands",
    "CA": "Canada",
    "DM": "Dominica",
    "MS": "Montserrat",
    "US": "United States",
    "AU": "Australia",
    "FJ": "Fiji",
    "FM": "Micronesia",
    "NZ": "New Zealand",
    "PW": "Palau",
    "PG": "Papua New Guinea",
    "SB": "Solomon Islands",
    "BT": "Bhutan",
    "LA": "Laos",
    "MN": "Mongolia",
    "LK": "Sri Lanka",
    "AI": "Anguilla",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "BS": "Bahamas",
    "BB": "Barbados",
    "BZ": "Belize",
    "BM": "Bermuda",
    "BO": "Bolivia",
    "BR": "Brazil",
    "KY": "Cayman Islands",
    "CL": "Chile",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "SV": "El Salvador",
    "GD": "Grenada",
    "GT": "Guatemala",
    "GY": "Guyana",
    "HN": "Honduras",
    "JM": "Jamaica",
    "MX": "Mexico",
    "NI": "Nicaragua",
    "PA": "Panama",
    "PY": "Paraguay",
    "PE": "Peru",
    "PR": "Puerto Rico",
    "KN": "St. Kitts and Nevis",
    "LC": "St. Lucia",
    "VC": "St. Vincent and The Grenadines",
    "SR": "Suriname",
    "TT": "Trinidad and Tobago",
    "TC": "Turks and Caicos",
    "UY": "Uruguay",
    "VE": "Venezuela",
    "KR": "South Korea",
    "BN": "Brunei",
    "KH": "Cambodia",
    "ID": "Indonesia",
    "MY": "Malaysia",
    "MM": "Myanmar",
    "PH": "Philippines",
    "SG": "Singapore",
    "TH": "Thailand",
    "VN": "Vietnam",
    "AD": "Andorra",
    "AT": "Austria",
    "BE": "Belgium",
    "DK": "Denmark",
    "FI": "Finland",
    "FR": "France",
    "DE": "Germany",
    "IS": "Iceland",
    "IE": "Ireland",
    "IT": "Italy",
    "LI": "Liechtenstein",
    "LU": "Luxembourg",
    "MT": "Malta",
    "MC": "Monaco",
    "NL": "Netherlands",
    "NO": "Norway",
    "PT": "Portugal",
    "ES": "Spain",
    "SE": "Sweden",
    "CH": "Switzerland",
    "GB": "United Kingdom"
  },
  region_name: {
    "af": "Africa",
    "hmt": "China(HK,MO,TW)",
    "chn": "China(Mainland)",
    "ee": "Eastern Europe",
    "in": "India",
    "jpn": "Japan",
    "me": "Middle East",
    "na": "North America",
    "oa": "Oceania",
    "other asia": "Other Asia",
    "sa": "South America",
    "kr": "South Korea",
    "sea": "Southeast Asia",
    "we": "Western Europe"
  },
  platform: {
    'googleplay': 'Google Play',
    'appstore': 'App Store',
    'PC': 'PC',
    "PlayStation": 'PlayStation',
    "Xbox": 'Xbox',
    "Nintendo": 'Nintendo',
    "twitch": 'twitch',
    "ytg": 'YouTube',
    'facebook': 'Facebook Gaming',
    'ios': 'iOS',
    'android': 'Android',
    'steam': 'Steam',
  },
  granularity: {
    "daily": "Day",
    "weekly": 'Week',
    "monthly": 'Month',
    "day": 'Day',
    "week": 'Week',
    "month": 'Month',
    "yearly": 'Year',
    "year": 'Year',
    "hourly": 'Hour',
    "hour": 'Hour'

  },
  game_type: ALL_TO_UPPERCASE_MAP,
  metrics: METRIC_DISPLAY_NAME
};

export const TIME_TYPE_MAP: TObjKeyValueString = {
  daily: 'Day',
  weekly: 'Week',
  monthly: 'Month',
  realtime: 'hour',
  minutes: 'hour',
  time: 'hour'
};

export const GAME_TYPE_ICON_MAP: TObjKeyValueString = {
  'mobile': 'other-icon',
  'pc': 'monitor',
  'console': 'game',
  'company': 'folded-graph',
  'pc/console': 'pc-console-combine'
};

export const FORMAT_MAP: TObjKeyValueString = {
  numerical: 'thousandsInit',
  percent: 'percent2Decimal',
  float: 'twoDecimal',

};


export const YAXIS_FORMAT_MAP: TObjKeyValueString = {
  numerical: 'not0IntBmk0',
  percent: 'percentInt',
  float: 'not0IntBmk0',
  smallType: 'twoDecimal',
};

// 产品要的很急，按理说后端扩展小数位类型，然后前端处理，但是这里前端先临时处理
export const SMALL_VAL_METRIC = ['arpu'];

export const TOOLTIPS_FORMAT_MAP: TObjKeyValueString = {
  numerical: 'thousandsInit',
  percent: 'percent2Decimal',
  float: 'thousands2Decimal',
};

export const TABLE_FORMAT_MAP: TObjKeyValueString = {
  numerical: 'thousandsInit',
  percent: 'percent2Decimal',
  float: 'thousands2Decimal',
};

export const DATE_FORMAT_MAP: TObjKeyValueString = {
  daily: 'day',
  weekly: 'day',
  monthly: 'month',
  hourly: 'hour',
  realtime: 'hour',
  minutes: 'hour',
  time: 'hour'
};

export const TOOLTIPS_DATE_FORMAT_MAP: TObjKeyValueString = {
  daily: 'day',
  weekly: 'day',
  monthly: 'month',
  hourly: 'minutes',
  realtime: 'minutes',
  minutes: 'minutes',
  time: 'minutes'
}; 

export const DIMENSION_TAB_NAME_MAP: TObjKeyValueString = {
  source: 'Source',
  region: 'Region',
  market_name: 'Country',
  platform: 'Platform',
  game_type: 'Game',
  metrics: 'Metric',
  granularity: 'Time',
  date: 'Date',
  time: 'Time',
  realtime: 'Time',
  game_name: 'Game Name',
  language: 'Language',
  buddle: 'Buddle',
  channel_name: "Channel",
  region_name: 'Region',
  code: 'Code',
  // 留存D1、D2都指标兜底，或许用不上
  retention_name: 'Metric'
};

export const DEEP_THINK_MODE = "deepthink";
export const FAST_QA_MODE = "fastqa";

/**
 * LocalStorage 存储 Key
 */
export const STORAGE_KEY = '__dba_selected_agent__';

// Copilot / 报告相关的跨页面共享 Key
// 报告窗口状态（是否有独立报告窗口在展示），Home 的 AgentRobot 与 Copilot 之间共享
export const COPILOT_REPORT_WINDOW_STATE_KEY = '__dba_copilot_report_window_state__';
// 当前激活窗口类型（copilot / report），用于 Copilot 内部窗口层级管理
export const COPILOT_ACTIVE_WINDOW_KEY = '__dba_copilot_active_window__';
// Copilot 报告使用的 sessionId（sourceSessionId），供 Chat / Copilot / Home 共享
export const COPILOT_REPORT_SESSION_ID_KEY = '__dba_copilot_report_session_id__';

/** Copilot 窗口模式：floating 悬浮窗口 / docked 右侧固定停靠 */
export type TCopilotWindowMode = 'floating' | 'docked';
/** Copilot 默认窗口模式持久化 Key（更多菜单「默认窗口」开关），重新打开时按此恢复 floating / docked */
export const COPILOT_WINDOW_MODE_KEY = '__dba_copilot_window_mode__';
/** Copilot 内嵌停靠时收起各业务系统左侧菜单（memoryStore + subscribe） */
export const COPILOT_LEFT_MENU_COLLAPSED_KEY = '__dba_copilot_left_menu_collapsed__';
/** 全局布局右侧内嵌槽 DOM id（common wrapper dbh-body-wrap） */
export const COPILOT_DOCK_PORTAL_ID = 'dbh-copilot-dock-portal';
/** Home 页内容区右侧内嵌槽 DOM id（与 hame-page-scroll 并列 flex） */
export const COPILOT_HOME_DOCK_PORTAL_ID = 'dbh-copilot-home-dock-portal';

/** 外部导入的 Copilot query / 前缀等配置（全局 store），由 useCopilotOpenBridge 写入、Chat 消费 */
export const COPILOT_EXTERNAL_QUERY_CONFIG_KEY = '__dba_copilot_external_query_config__';

/** 标记当前是否为"未开始对话"的新会话，非空 = 新会话，空字符 = 旧会话 */
export const COPILOT_NEW_SESSION_ID_KEY = '__dba_copilot_new_session_id__';

// 权限申请地址
export const PERMISSION_URL = 'https://appauth.intlgame.com';

// Techland 组织的默认 Agent ID
export const TECHLAND_DEFAULT_AGENT_ID = '103cf512-f90d-467e-bc6c-fb03f9c8b9e1';

// DataBrain Agent ID
export const DATABRAIN_AGENT_ID = 'f88456d8-f295-4628-8fbe-e3593fece9da';

// DataBrain 2.0 Agent ID
export const DATABRAIN_AGENT_ID2 = '04f17af1-4477-4229-9f64-099e2a996a1e';
/** Token 月度模型额度上限 fallback（美元），API 未返回 model_cost_limit 时使用 */
export const AGENT_MONTHLY_QUOTA_LIMIT_USD = 500;

/**
 * 智能路由模式列表
 * className: 用于区分不同模式的按钮样式类名
 * activeIcon: 选中态的图标
 * showIcon: 是否在触发按钮上显示图标
 */
export const THINKING_MODES = [
  {
    agentId: 'auto',
    icon: ModeAutoIcon,
    name_cn: '智能路由',
    name: 'Auto',
    description_cn: '智能匹配最佳模式',
    description: 'Intelligently match the best mode',
    className: 'dba-thinking-mode--auto',
    showIcon: false,
  },
  {
    agentId: 'fastqa',
    icon: ModeFastIcon,
    activeIcon: ModeFastActiveIcon,
    name_cn: '快速回答',
    name: 'Fast QA',
    description_cn: '答复更简洁，较快',
    description: 'Gives quick, basic answers (faster response)',
    className: 'dba-thinking-mode--fast',
    showIcon: true,
    arrowIcon: FastPointIcon,
    arrowIconActive: FastPointIcon,
  },
  {
    agentId: 'deepthink',
    icon: ModeDeepIcon,
    activeIcon: ModeDeepActiveIcon,
    name_cn: '深度思考',
    name: 'Deep Thinking',
    description_cn: '答复更全面，稍慢',
    description: 'Gives detailed, in-depth answers (slower response)',
    className: 'dba-thinking-mode--deep',
    showIcon: true,
    arrowIcon: DeepseekPointIcon,
    arrowIconActive: DeepseekPointIcon,
  },
];

export const FILE_DOCUMENT_TYPE = "document";
export const FILE_IMAGE_TYPE = "image";

/**
 * Chat Engine 映射配置
 * 特定 Agent ID 对应的聊天引擎
 */
export const CHAT_ENGINE_MAP: Record<string, string> = {
  '41': 'gpt-4.1',
  '25': 'gemini-2.5-flash',
  "52": 'gpt-5.2',
  "31": "vertex_ai/gemini-3-flash-preview",
  "46": "claude-sonnet-4-6",
  "47": "claude-opus-4-7"
};

// 使用常量定义错误码映射关系
export const ERROR_CODES = {
  PARSE_ERROR: '-32700',
  INVALID_REQUEST: '-32600',
  METHOD_NOT_FOUND: '-32601',
  INVALID_PARAMS: '-32602', 
  INTERNAL_ERROR: '-32603',
  MAX_TURNS: '-32000',
  INVALID_AGENT: '-32006',
  INVALID_IMAGE: '-32007',
  OVER_TOKEN: '-32008',
  RATE_LIMIT: '-32009',
  REQUEST_LIMIT: '429',
  EXECUTION_TIMEOUT: '-32011',
  INVALID_INPUT: '-32012',
} as const;

// 流式数据中按"图表数据"统一处理的类型集合（结构均为 { type, value: object }）
export const CHART_DATA_TYPES = ['biData', 'bq_chart', 'echartsOption'] as const;
export type TChartDataType = (typeof CHART_DATA_TYPES)[number];

// 流式数据中"文本拼接型"统一处理的类型集合（同类型 value 字符串累加）
export const TEXT_CONCAT_DATA_TYPES = ['data_description', 'complete_summary'] as const;
export type TTextConcatDataType = (typeof TEXT_CONCAT_DATA_TYPES)[number];

// 文档类数据子类型集合（统一以 type:'document' 渲染，subType 透传真实类型）
export const DOCUMENT_DATA_SUBTYPES = ['document', 'ai_excel_file', 'magic_poster_file'] as const;
export type TDocumentDataSubType = (typeof DOCUMENT_DATA_SUBTYPES)[number];

export const DIMENSION_WHITELIST = ['game_name', 'game_type', 'source', 'date', 'market_name', 'granularity', 'platform',  'language', 'channel_name', 'region', 'code', 'region_name'];

export const UPLOAD_FILE_IMG_TYPE_LIST = [
  'jpg', 'png',
  'webp', 'jpeg',
];

// 支持的所有文件类型
export const UPLOAD_FILE_TYPE_LIST = [
  // 图片类型
  ...UPLOAD_FILE_IMG_TYPE_LIST,
  // 文档类型
  'pdf', 'doc', 'docx', 'md', 'pptx', 'xlsx', 'html',
  // // 表格类型
  // 'xls', 'csv',
  // // 演示文稿类型
  // 'ppt', 'pptx', 'txt',
];

// 文件状态映射
export const FILE_STATUS_MAP: TObjKeyValueString = {
  // 解析成功
  'Success': 'success',
  // 解析失败
  'Unknown': 'error',
  // 超过5分钟, 还没解析完成,默认失败,前端已设置3分钟超时,会直接中断, 触发catch
  'Parsing': 'error',
};

export const DATE_OR_TIME_AXIS_TYPE: string [] = ['date', 'time', 'hour'];

export const DATE_OR_TIME_DATA_TYPE: string []  = ['date', 'time', 'realtime', 'hour'];
// 反馈区问题列表
export const FEED_BACK_MESSAGES_LIST = [
  {
    id: 0,
    text: '回答与问题无关',
    textEn: 'Irrelevant to my question',
  },
  {
    id: 1,
    text: '事实或数据不准确',
    textEn: 'Contains inaccurate facts',
  },
  {
    id: 2,
    text: '回答过于简略',
    textEn: 'Too brief / Incomplete',
  },
  {
    id: 3,
    text: '回答质量不足',
    textEn: 'Lack of answer quality',
  },
  {
    id: 4,
    text: '出现错误或卡顿',
    textEn: 'Buggy or slow',
  },
  {
    id: 5,
    text: '其他 (请补充)',
    textEn: 'Other (please specify)',
  },
];


// 协议中新增了一些恶format支持，为兼容之前的date、time等，在此做映射处理，新增的数据格式化，其实不需要映射
export const FORMAT_RULE_MAP: TObjKeyValueString = {
  date: 'day',
  time: 'hour',
  datetime: 'minutes',
  yearMonth: 'month',
  monthDay: 'mDay'
};

export const EXCEL_TABLE_FORMAT_MAP: TObjKeyValueString = {
  numerical: '#,##0',
  percent: '0.00%',
  float: '0.00',
  thousandsInit: '#,##0', 
  percent2Decimal: '0.00%',
  thousands2Decimal: '0.00',
  day: 'yyyy-mm-dd',
  week: 'yyyy-mm-dd',
  hour: 'hh:mm:ss',
  month: 'yyyy-mm',
  mDay: 'mm-dd',
  year: 'yyyy',
  yearMonth: 'yyyy-mm',
  yearMonthDay: 'yyyy-mm-dd',
  yearMonthDayHour: 'yyyy-mm-dd hh',
  yearMonthDayHourMinute: 'yyyy-mm-dd hh:mm',
  yearMonthDayHourMinuteSecond: 'yyyy-mm-dd hh:mm:ss',
  twoDecimal: '0.00',
  oneDecimal: '0.0',
  int: '0',
  absPercentInt: '0%',
  absPercent1Decimal: '0.0%',
  absPercent2Decimal: '0.00%',
  percentInt: '0%',
  percent1Decimal: '0.0%',
  not0IntBmk0: '0.00',
};

export const SPECIAL_TIME_TYPE: TObjKeyValueString = {
  realtime: 'hour',
  week: 'day',
};

/**
 * 语言文件扩展名映射表
 */
export const EXTENSION_MAP: Record<string, string> = {
  javascript: '.js',
  python: '.py',
  java: '.java',
  c: '.c',
  cpp: '.cpp',
  'c++': '.cpp',
  'c#': '.cs',
  ruby: '.rb',
  php: '.php',
  swift: '.swift',
  'objective-c': '.m',
  kotlin: '.kt',
  typescript: '.ts',
  go: '.go',
  perl: '.pl',
  rust: '.rs',
  scala: '.scala',
  haskell: '.hs',
  lua: '.lua',
  shell: '.sh',
  sql: '.sql',
  html: '.html',
  css: '.css',
  json: '.json',
  markdown: '.md',
};

/**
 * 语言映射表：将className中的语言标识映射到Ace Editor的mode
 */
export const LANGUAGE_MODE_MAP: Record<string, string> = {
  javascript: 'javascript',
  js: 'javascript',
  typescript: 'typescript',
  ts: 'typescript',
  python: 'python',
  py: 'python',
  java: 'java',
  c: 'c_cpp',
  cpp: 'c_cpp',
  'c++': 'c_cpp',
  'c#': 'csharp',
  csharp: 'csharp',
  ruby: 'ruby',
  php: 'php',
  swift: 'swift',
  'objective-c': 'objectivec',
  objectivec: 'objectivec',
  kotlin: 'kotlin',
  go: 'golang',
  golang: 'golang',
  perl: 'perl',
  rust: 'rust',
  scala: 'scala',
  haskell: 'haskell',
  lua: 'lua',
  shell: 'sh',
  sh: 'sh',
  bash: 'sh',
  sql: 'sql',
  mysql: 'mysql',
  json: 'json',
  html: 'html',
  css: 'css',
  scss: 'scss',
  markdown: 'markdown',
  md: 'markdown',
};

// 下载excel数据量和图例数量阈值
export const SHOW_EXCEL_DOWNLOAD_DATA_LENGTH = 100;
export const SHOW_EXCEL_DOWNLOAD_LEGEND_COUNT = 20;

// TODO: 后续可以考虑从接口获取，目前先硬编码默认 skill_name（与技能包名 / specified_skills.name 一致）
export const GALLERY_DEFAULT_SKILL = 'databrain-agent-service';
